(() => {
  const initializeFinderStatus = () => {
    const shell = document.querySelector('.xh-finder-shell');
    const mount = shell?.querySelector('#cm-ymm');
    if (!mount || mount.dataset.xhObserved) return;
    mount.dataset.xhObserved = 'true';
    mount.addEventListener('keydown', event => {
      if (event.defaultPrevented || !['Enter', ' '].includes(event.key)) return;
      const control = event.target.closest('.cm_vehicle-widget_button');
      if (!control || control.getAttribute('disabled') === 'true' || control.getAttribute('aria-disabled') === 'true') return;
      event.preventDefault();
      control.click();
    });
    const loading = shell.querySelector('[data-xh-loading]');
    const fallback = shell.querySelector('[data-xh-fallback]');
    loading.hidden = false;
    let timer;
    const update = () => {
      const firstSelect = mount.querySelector('select');
      if (!firstSelect || firstSelect.disabled || !Array.from(firstSelect.options).some(option => option.value && option.value !== '_current' && !option.disabled)) return false;
      loading.hidden = true;
      fallback.hidden = true;
      clearTimeout(timer);
      observer.disconnect();
      return true;
    };
    const observer = new MutationObserver(update);
    if (!update()) {
      observer.observe(mount, {childList: true, subtree: true});
      timer = setTimeout(() => {
        loading.hidden = true;
        fallback.hidden = false;
      }, 15000);
    }
  };
  initializeFinderStatus();
  document.addEventListener('shopify:section:load', initializeFinderStatus);
})();
